import React from "react"
import PropTypes from "prop-types"
import { MapWithMarkers } from "components"

const DealerMapPage = ({
  dealerName,
  lat,
  lng
}) => (
  <MapWithMarkers
    map={{
      center: {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      },
      zoom: 17
    }}
    activeIndex={0}
    locations={[{
      name: dealerName,
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    }]}
  />
)

DealerMapPage.propTypes = {
  dealerName: PropTypes.string.isRequired,
  lat: PropTypes.string.isRequired,
  lng: PropTypes.string.isRequired
}

export default DealerMapPage



// WEBPACK FOOTER //
// ./src/blocks/dealer-map-page/index.jsx